import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "core/img/imagewithbasebath";
import PropTypes from "prop-types";
import Input from "Components/UI/Input";
// import Select from "react-select";
import dayjs from "dayjs";
import { DatePicker, Select } from "antd";
import { Controller, useFormContext } from "react-hook-form";
const dateFormat = "YYYY-MM-DD";
const AssignShift = ({
  show,
  setShow,
  employees,
  // selectedEmployees,
  // setSelectedEmployees,
  shiftPolicies,
  saveShift,
}) => {
  const {
    handleSubmit,
    setValue,
    trigger,
    watch,
    setError,
    clearErrors,
    control,
    formState: { errors },
  } = useFormContext();

  const employeeOptions = Array.isArray(employees)
    ? employees
        ?.filter((o) => o.isActive === true)
        .map((o) => ({
          label: `${o.uniqueId}-${o.fullName}`,
          value: o.employeeCode,
          groupCode: o.groups,
        }))
    : [];

  const shiftPolicyOptions = Array.isArray(shiftPolicies)
    ? shiftPolicies
        // ?.filter((o) => o.isActive === true)
        .map((o) => ({
          label: o.shiftName,
          value: o.shiftPolicyID,
        }))
    : [];

  const showSettings = () => {
    setShow(!show);
  };

  const shiftAssignHandler = (data) => {
    if (data?.selectedEmployees.length <= 0) {
      setError("selectedEmployees", {
        type: "custom",
        message: "Please select employees",
      });
      return;
    }

    if(!data?.shiftID || data?.shiftID === "") {
      setError("shiftID", {
        type: "custom",
        message: "Please select shift",
      });
      return;
    }
    console.log("shiftAssignHandler data", employees, data);
    // setSelectedEmployees(data.selectedEmployees);
    clearErrors("selectedEmployees");
    clearErrors("shiftID");
    const shiftMappingData = data?.selectedEmployees?.map((employee) => ({
      companyCode: data.companyCode,
      employeeCode: employee?.value?.toString() || employee.toString(),
      groupCode:
        employees.find((e) => e.employeeCode === employee).groups || "",
      shiftID: data.shiftID,
      scheduleFromDate: data.scheduleFromDate,
      scheduleToDate: data.scheduleToDate,
      createUser: data?.createUser || "",
      remarks: data?.remarks || "",
      approvedBy: data?.approvedBy || "",
      isActive: true,
      locationCode: data?.locationCode || "",
    }));

    saveShift(shiftMappingData);
    showSettings();
    setValue("selectedEmployees", []);
  };

  return (
    <>
      <div
        className={
          show
            ? "sidebar-settings nav-toggle show-settings"
            : "sidebar-settings nav-toggle"
        }
        id="layoutDiv"
        // onclick="toggleClassDetail()"
      >
        <div className="sidebar-content sticky-sidebar-one">
          <div className="sidebar-header">
            <div className="sidebar-theme-title">
              <h5>Assign Shift</h5>
              {/* <p></p> */}
            </div>
            <div className="close-sidebar-icon d-flex">
              <Link className="sidebar-close" to="#" onClick={showSettings}>
                X
              </Link>
            </div>
          </div>
          <div className="sidebar-body p-0">
            <form id="theme_color" onSubmit={handleSubmit(shiftAssignHandler)}>
              <div className="theme-mode mb-0">
                <div className="theme-body-main">
                  <div className="theme-head">
                    <h6>Assign Shift</h6>
                    {/* <p></p> */}
                  </div>
                  <div className="form-row row">
                    <div className="col-12 ere mb-3">
                      <div className="form-floating">
                        <Controller
                          name="selectedEmployees"
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              // name="selectedEmployees"
                              placeholder="Select Employees"
                              className={`form-control ${
                                errors.selectedEmployees ? "is-invalid" : ""
                              }`}
                              // defaultValue={watch(`selectedEmployees`) || []}
                              options={employeeOptions}
                              labelInValue={true}
                              mode="multiple"
                              onChange={(selectedOptions) => {
                                console.log(selectedOptions);
                                setValue(
                                  "selectedEmployees",
                                  Array.isArray(selectedOptions)
                                    ? selectedOptions.map(
                                        (option) => option.value
                                      )
                                    : []
                                );
                              }}
                              showSearch
                              allowClear
                              onClear={() => {
                                setValue("selectedEmployees", []);
                              }}
                              style={{ width: "100%", height: "auto" }}
                              getPopupContainer={(triggerNode) =>
                                triggerNode.parentNode
                              }
                              // disabledDate={(current) => {
                              //   return current && current > dayjs().startOf("day");
                              // }}
                            />
                          )}
                        />
                         {errors.selectedEmployees && (
                        <div className="invalid-feedback">
                          {errors.selectedEmployees?.message || "Invalid input"}
                        </div>
                      )}
                      </div>
                      {/* <Input
                        name="selectedEmployees"
                        type="commonSelect"
                        placeholder="Select Employee"
                        className={`form-control ${
                          errors.selectedEmployees ? "is-invalid" : ""
                        }`}
                        label="Employee"
                        labelClassName="form-label"
                        optionData={employeeOptions}
                        required={true}
                        requiredMessage="Employee is required"
                        onChange={(selectedOptions) => {
                          console.log(selectedOptions);
                          setValue(
                            "selectedEmployees",
                            Array.isArray(selectedOptions)
                              ? selectedOptions.map((option) => option.value)
                              : []
                          );
                        }}
                        // defaultValue={employeeOptions.filter((option) =>
                        //   watch("selectedEmployees")?.includes(option.value)
                        // )}
                        labelInValue={true}
                        mode="multiple"
                        showSearch
                        allowClear
                        onClear={() => {
                          setValue("selectedEmployees", []);
                        }}
                        style={{ height: "auto" }}
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentNode
                        }
                      /> */}
                    </div>

                    <div className="col-12 ere mb-3">
                      <Input
                        name="shiftID"
                        type="commonSelect"
                        placeholder="Select Shift"
                        className={`form-control ${
                          errors.shiftID ? "is-invalid" : ""
                        }`}
                        label="Shift"
                        labelClassName="form-label"
                        optionData={shiftPolicyOptions}
                        required={true}
                        requiredMessage="Employee is required"
                        onChange={(option) => {
                          setValue("shiftID", option);
                        }}
                        defaultValue={watch("shiftID")}
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentNode
                        }
                      />
                    </div>

                    <div className="col-12 ere mb-3">
                      <label htmlFor="light_mode" className="checktoggles">
                        <span className="form-label">From Date</span>
                      </label>
                      <Controller
                        name={"scheduleFromDate"}
                        control={control}
                        defaultValue={watch("scheduleFromDate")}
                        render={({ field }) => (
                          <DatePicker
                            {...field}
                            placeholder="Select From Date"
                            value={
                              field.value
                                ? dayjs(field.value, dateFormat)
                                : null
                            }
                            format={dateFormat}
                            className="form-control"
                            onChange={(date) => {
                              setValue(
                                "scheduleFromDate",
                                date ? dayjs(date).format(dateFormat) : null
                              );
                              setValue(
                                "scheduleToDate",
                                date
                                  ? dayjs(date).add(6, "day").format(dateFormat)
                                  : null
                              );

                              trigger("scheduleFromDate");
                            }}
                            disabledDate={
                              (current) =>
                                current && current <= dayjs().subtract(1, "day") //.endOf("day")
                            }
                            getPopupContainer={(trigger) => trigger.parentNode}
                          />
                        )}
                      />
                      {errors.fromDate && (
                        <div className="invalid-feedback">
                          {errors.fromDate?.message || "Invalid input"}
                        </div>
                      )}
                    </div>

                    <div className="col-12 ere mb-3">
                      <label htmlFor="light_mode" className="checktoggles">
                        <span className="form-label">To Date</span>
                      </label>
                      <Controller
                        name={"scheduleToDate"}
                        control={control}
                        defaultValue={watch("scheduleToDate")}
                        render={({ field }) => (
                          <DatePicker
                            {...field}
                            placeholder="Select To Date"
                            value={
                              field.value
                                ? dayjs(field.value, dateFormat)
                                : null
                            }
                            format={dateFormat}
                            className="form-control"
                            onChange={(date) => {
                              setValue(
                                "scheduleToDate",
                                date ? dayjs(date).format(dateFormat) : null
                              );
                              trigger("scheduleToDate");
                            }}
                            disabledDate={
                              (current) =>
                                current <=
                                dayjs(
                                  new Date(watch("scheduleFromDate"))
                                ).subtract(1, "day") //.endOf("day")
                            }
                            getPopupContainer={(trigger) => trigger.parentNode}
                          />
                        )}
                      />
                      {errors.fromDate && (
                        <div className="invalid-feedback">
                          {errors.toDate?.message || "Invalid input"}
                        </div>
                      )}
                    </div>
                    <div className="col-12 ere mb-3">
                      <Input
                        type="text"
                        name="remarks"
                        placeholder="Remaks"
                        label="Remark"
                        className="form-control"
                        labelClassName="form-label"
                        required={true}
                        requiredMessage="Remark is required"
                      />
                    </div>
                  </div>
                </div>
                <div className="sidebar-footer">
                  <div className="row">
                    <div className="col-xl-6">
                      <div className="footer-preview-btn">
                        <button
                          type="button"
                          className="btn btn-secondary w-100"
                          onClick={showSettings}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className="footer-reset-btn">
                        <button type="submit" className="btn btn-primary w-100">
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

AssignShift.propTypes = {
  show: PropTypes.bool.isRequired,
  setShow: PropTypes.func.isRequired,
  employees: PropTypes.array.isRequired,
  // selectedEmployees: PropTypes.array.isRequired,
  // setSelectedEmployees: PropTypes.func.isRequired,
  shiftPolicies: PropTypes.array.isRequired,
  saveShift: PropTypes.func.isRequired,
};

export default AssignShift;
